/**
 * Sheet cell with time data
 *
 * Copyright (C) 2018D Noom, Inc.
 * @author hubert
*/


import React from "react";
import moment from "moment";
import { If } from "@noom/noomscape";


const SheetDateField = ({
  label,
  value,
  editMode,
  onChange,
}) => (
  <div className="landlookSheet-field">
    <div className="landlookSheet-label">
      <If
        if={ (value === null || value === undefined) }
        then={ () => (
          <div className="landlookSheet-indicator">
            <div className="landlookSheet-indicatorInner"/>
          </div>
        ) }
      />
      { label }
    </div>
    <div className={ (value === null || value === undefined) ? "landlookSheet-noValue" : "landlookSheet-value" }>
      <If
        if={ editMode }
        then={ () => (
          <input
            className="landlookSheet-input"
            type="date"
            value={ value }
            onChange={ onChange }
          />
        ) }
        else={ () => (
          <React.Fragment>
            { (value === null || value === undefined) ? "N/A" : value }
          </React.Fragment>
        ) }
      />

    </div>
  </div>
);


export default SheetDateField;
